import {Component} from '@angular/core';
import {VouchersService} from "@app/features/vouchers/vouchers.service";
import {NavigationService} from "@shared/services/navigation-service.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {DataService} from "@shared/services/data.service";
import {FileHandle} from "@shared/directives/dragDrop.directive";
import {ToastService} from "@shared/services/toast.service";

@Component({
  selector: 'app-create-voucher',
  templateUrl: './create-voucher.component.html',
  styleUrls: ['./create-voucher.component.scss']
})
export class CreateVoucherComponent {
  public isSubmitted = false;
  public editMode = false;
  public logoFileToUpload: any;
  public tos = "";
  logoFileReader: FileReader = new FileReader();
  public logoPreview: string | ArrayBuffer | null | undefined;
  public store:any;
  modalRef?: BsModalRef;
  public redeemCode: string = '';
  public redeemDone = false;
  public invalidCode = false;
  public voucherId :any;
  public countryCode: any;
  public voucher = {
    title: "",
    countryCode: "",
    logoImageUrl: '',
    description: "",
    redems: [
      "",
    ],
    tos: [
      "",
    ],
    price: "",
    status: "ACTIVE",
    codesCount: "",
    voucherValue: "",
    isVisible: true,
    storeId: 3,
    whereToRedeem: {
      name: "",
      latitude: 31.0,
      longitude: 35.0,
      country: {
        name: "",
        countryCode: "",
      },
      id: 2,
    }
  }

  constructor(public vouchersService: VouchersService,
              public toast: ToastService,
              public navigation: NavigationService,
              public spinner: NgxSpinnerService,
              public router: Router,
              public dataService: DataService,
              private modalService: BsModalService,
              public route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.voucherId = this.route.snapshot.paramMap.get('id');
    if( this.voucherId != -1){
      this.editMode = true;
      this.voucher = JSON.parse(localStorage.getItem('targetVoucher')?? '');
      this.voucher.isVisible = this.voucher.status == "INACTIVE" ? false : true 
    }
    this.store = JSON.parse(localStorage.getItem('store')?? '');
    this.voucher = {...this.voucher, storeId: this.store.id};
    this.countryCode = localStorage.getItem('countryCode');
    this.initTOU();
  }

  public onLogoChange(event: { target: any; }) {
    const input = event.target;
    if (input.files && input.files[0]) {
      this.logoFileReader.readAsDataURL(input.files[0]);
      this.logoFileToUpload = input.files[0];
      this.spinner.show();
      this.uploadLogo(this.logoFileToUpload).then((res: any) => {
        this.spinner.hide();
        this.voucher = {...this.voucher, logoImageUrl: res.fileUrl}
      }, error=>{
        let errorMessage = error && error.error ? error.error.error : error.name;

        console.log(error)
        this.toast.error(errorMessage?? 'Error uploading image')
        this.spinner.hide();

      })
    }
  }

  onLogoChangeDropped(files: FileHandle[]): void {
    if (files && files[0]) {
      this.logoFileReader.readAsDataURL(files[0].file);
      this.logoFileToUpload = files[0].file;
      this.spinner.show();
      this.uploadLogo(this.logoFileToUpload).then((res: any) => {
        this.spinner.hide();
        this.voucher = {...this.voucher, logoImageUrl: res.fileUrl}
      }, error=>{
        console.log(error)
        let errorMessage = error && error.error ? error.error.error : error.name;
        this.toast.error(errorMessage?? 'Error uploading image')

        this.spinner.hide();

        }
      )
    }
  }

  uploadLogo(file: any) {
    return this.dataService.uploadImage(file);
  }

  public onAddStep() {
    const list = this.voucher.redems;
    list.push("")
    this.voucher = {...this.voucher, redems: list}
  }

  public onDeleteStep(index: number) {
    const list = this.voucher.redems;
    if (list.length <= 1) {
      return;
    }
    list.splice(index, 1)
    this.voucher = {...this.voucher, redems: list}
  }

  public initTOU() {
    this.tos = this.voucher.tos.toString().replace(',', '\n');
  }

  public SaveVoucher() {
    this.isSubmitted = true;
    if (!this.voucher.title.toString().trim() || !this.voucher.voucherValue.toString().trim() || !this.voucher.price.toString().trim() || !this.voucher.codesCount.toString().trim()
      || !this.voucher.description.toString().trim() || !this.voucher.tos || !this.voucher.logoImageUrl || !this.voucher.redems
    ) {
      return;
    }
    this.voucher.status = this.voucher.isVisible ? "ACTIVE" : "INACTIVE";
    this.voucher = {...this.voucher,tos: this.tos.split('\n') }
    this.spinner.show();
    this.vouchersService.createVoucher(this.voucher, this.editMode).subscribe((res: any) => {
        const message = this.editMode? "Voucher Updated Successfully" : "Voucher Created Successfully";
      this.toast.success(message);
        this.router.navigate(['/vouchers']);
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        console.log(error);
      })
  }

  trackByFn(index: any, item: any) {
    return index;
  }
  public openGenerate(template: any) {
    this.redeemDone = false;
    this.redeemCode = "";
    this.invalidCode = false;
    this.modalRef = this.modalService.show(template);

  }

  public generateCode() {
    this.spinner.show();
    this.vouchersService.generateCode(this.voucherId, this.redeemCode).subscribe((res: any) => {
      this.redeemDone = true;
      this.voucher ={...this.voucher, codesCount: this.voucher.codesCount + this.redeemCode}
      this.spinner.hide();
    }, error => {
      console.log(error);
    })

  }

  public onDone() {
    this.modalRef?.hide()
  }
}
